import { render, staticRenderFns } from "./ManaBadge.vue?vue&type=template&id=0ee9b335&"
import script from "./ManaBadge.vue?vue&type=script&lang=js&"
export * from "./ManaBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports